import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IOpportunityAttachment } from "../../utils/types/models";

export default createEntityReducer<IOpportunityAttachment>(Endpoint.OpportunityAttachments, Endpoint.OpportunityAttachmentsList);
